import { DateFormat, SemboDate } from '@libs/sembo-dates';

import type {
  CurrentMonthLoaderDayTile,
  CurrentMonthPastDayTile,
  PreviousMonthDayTile,
  WeekDayTile,
} from '../models';
import { PriceCalendarTileType } from '../models';

export function getWeekDayTiles(weekdays: string[]): WeekDayTile[] {
  return weekdays.map((day: string) => ({
    type: PriceCalendarTileType.WeekDay,
    text: day,
  }));
}

export function getPreviousMonthTiles(
  firstDayInMonth: Date,
  weekdays: string[]
): PreviousMonthDayTile[] {
  const firstDayShortName = new SemboDate(firstDayInMonth).format(
    DateFormat.ShortDayName
  );
  const firstDayIndex = weekdays.findIndex(
    (day: string) => day === firstDayShortName
  );

  return Array.from({ length: firstDayIndex }, () => ({
    type: PriceCalendarTileType.PreviousMonthDay,
  }));
}

export function getCurrentMonthPastDayTile(
  date: Date
): CurrentMonthPastDayTile {
  return {
    type: PriceCalendarTileType.CurrentMonthPastDay,
    text: date.getDate().toString(),
    date,
  };
}

export function getCurrentMonthLoaderDayTile(
  date: Date
): CurrentMonthLoaderDayTile {
  return {
    type: PriceCalendarTileType.CurrentMonthLoaderDay,
    text: date.getDate().toString(),
    date,
  };
}
